import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ArrowRightSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ArrowRightSVG;
